export default {
  name: '',
  code: '',
  status: 'active',
  description: '',
  invoice: 'always',
  unit: '',
  schema_type: 'flat',
  pricing_schema_attributes: {
    minimum_price: '',
    price: '',
    schema_type: 'flat',
    pricing_ranges_attributes: [{
      start_quantity: '',
      end_quantity: '',
      price: '',
      overage_price: '',
    }],
  },
};
